import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState, PdfSplitProgress, PdfSplitProgressMessage } from 'editor/src/store/gallery/types';
import putPdfPagesInUploadOrder from 'editor/src/store/gallery/utils/putPdfPagesInUploadOrder';

import notNull from 'editor/src/util/notNull';

const setPdfSplitProgressReducer = (state: GalleryState, action: PayloadAction<PdfSplitProgressMessage>) => {
  const splits = state.pdfSplits ?? [];
  const index = splits.findIndex((split) => split.uploaderId === action.payload.uploaderId);
  // A file uploaded again gets the same uploader id, so its new split starts over instead of inheriting the old one.
  const split: PdfSplitProgress =
    action.payload.status === 'splitting' ? action.payload : { ...splits[index], ...action.payload };

  if (split.status === 'done' && split.pageImageIds) {
    putPdfPagesInUploadOrder(state, split.uploaderId, split.pageImageIds.filter(notNull));
  }

  // A single page is just an image, so there is nothing to tell once the page count is known.
  const pages = split.pagesTotal ?? split.pageImageIds?.length;
  const isSinglePage = split.status === 'done' ? (pages ?? 0) <= 1 : split.status === 'saving' && pages === 1;
  if (isSinglePage) {
    state.pdfSplits = splits.filter(({ uploaderId }) => uploaderId !== split.uploaderId);
  } else if (index === -1) {
    state.pdfSplits = [...splits, split];
  } else {
    splits[index] = split;
  }
};

export default setPdfSplitProgressReducer;
